module.exports = __webpack_public_path__ + "static/img/vs.96b16832.png";